import React, {useState} from "react";
import TableViewer from "./table-viewer";
import GraphViewer from "./graph-viewer";
import {Button, ButtonGroup, ButtonToolbar, Dropdown, Icon, IconButton} from "rsuite";
import SioIcon from "../../icon/rsuite-icon-font/SioIcon";
import "./time-aggregation-viewer.less";
import {toLabel} from "./utils";

const VIEWS = Object.freeze([
    ["table", "fa fa-grip", TableViewer],
    ["graph", "fa fa-chart-line", GraphViewer]
]);

const DIFF = Object.freeze([
    [false, "ohne Vergleich"],
    ["period", "Vergleich mit vorherigem Zeitraum"],
    ["year", "Vergleich mit Vorjahr"],
]);

const EXEPTION_LIST = ['ALL', '1d', '1w']

export const TimeAggregation = ({data, columns, grouping, labels, interval, excel}) => {

    if (!columns?.length) {
        return null;
    }

    const [view, switchView] = useState(VIEWS[0][0]);
    const [showSum, setShowSum] = useState(0 < grouping?.length);
    const [diff, setDiff] = useState([false]);

    const Viewer = VIEWS.find(([name]) => view === name)[2];
    
    if(EXEPTION_LIST.includes(interval) && diff.length !== 1) { setDiff([false]) };


    return (
        <div className="panel">
            <div className="panel-body" style={{padding: "10px"}}>

                <TimeAggregationToolbar
                    view={view}
                    switchView={switchView}
                    showSum={showSum}
                    setShowSum={setShowSum}
                    interval={interval}
                    diff={diff}
                    setDiff={setDiff}
                    grouping={grouping}
                    excel={excel}
                />

                <Viewer
                    data={data}
                    columns={columns}
                    labels={labels}
                    grouping={grouping}
                    showSum={showSum}
                    interval={interval}
                    diff={diff}
                />

            </div>
        </div>
    )
}

const TimeAggregationToolbar = ({view, switchView, showSum, setShowSum, grouping, diff, setDiff, excel, interval}) => {

    return (
        <>
            <div className="pull-right text-right">
                <ButtonGroup>
                    <IconButton title="Excel-Export" placement="left" onClick={() => excel(true)}
                                icon={<SioIcons icon="fa fa-circle-down"/>}/>

                    <Button onClick={() => excel(false)}>
                        Roh-Daten Export
                    </Button>
                </ButtonGroup>
            </div>

            <ButtonToolbar>
                <ButtonGroup>
                    {VIEWS.map(([name, icon]) => (
                        <IconButton
                            key={name}
                            active={view === name}
                            onClick={() => switchView(name)}
                            icon={<SioIcons icon={icon}/>}
                        />
                    ))}
                </ButtonGroup>

                {0 < grouping?.length && (
                    <>
                        <IconButton
                            active={showSum}
                            onClick={() => setShowSum(!showSum)}
                            title="Summen zeigen"
                            icon={<SioIcons icon="fa fa-check-double"/>}
                        />
                    </>
                )}

                {"table" === view && (
                    <>
                        <Dropdown title={DIFF.find(([d]) => d === diff[0])[1]}>
                            {
                                EXEPTION_LIST.includes(interval) ? 
                                    <Dropdown.Item key={false}
                                            active={true}
                                            onClick={() => setDiff([false])}>
                                                {'ohne Vergleich'}
                                    </Dropdown.Item>
                                :
                                DIFF.map(([key, label]) => (
                                    <Dropdown.Item key={key}
                                               active={diff[0] === key}
                                               onClick={() => key ? setDiff([key, diff[1] ?? "diff-percentage"]) : setDiff([false])}>
                                        {label}
                                    </Dropdown.Item>
                                ))
                            }
                        </Dropdown>

                        {diff[0] && (
                            <ButtonGroup>
                                <IconButton
                                    active={"diff-percentage" === diff[1]}
                                    icon={<SioIcons icon="fa fa-percent"/>}
                                    onClick={() => setDiff([diff[0], "diff-percentage"])}
                                />
                                <IconButton
                                    active={"diff" === diff[1]}
                                    icon={<SioIcons icon="fa fa-plus-minus"/>}
                                    onClick={() => setDiff([diff[0], "diff"])}
                                />
                            </ButtonGroup>
                        )}
                    </>
                )}

            </ButtonToolbar>
        </>
    );
}

const SioIcons = ({icon}) => <SioIcon icon={" " + icon}/>;

const makeDropdown = (data, grouping, labels, level) => Object.entries(data)
    .map(([group, subData]) => "__sums__" === group ? null :
        subData instanceof Array ? (
            <Dropdown.Item active={0 === level} key={group}>{toLabel(group, labels[grouping[level]])}</Dropdown.Item>
        ) : (
            <Dropdown.Menu key={group} active={0 === level} title={toLabel(group, labels[grouping[level]])}>
                {makeDropdown(subData, grouping, labels, level + 1)}
            </Dropdown.Menu>
        ));

export default TimeAggregation;
